import { render, staticRenderFns } from "./param-sagefemme.html?vue&type=template&id=0c2dd332&scoped=true&external"
import script from "./param-sagefemme.js?vue&type=script&lang=js&external"
export * from "./param-sagefemme.js?vue&type=script&lang=js&external"
import style0 from "./param-sagefemme.scss?vue&type=style&index=0&id=0c2dd332&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2dd332",
  null
  
)

export default component.exports